module.exports = __webpack_public_path__ + "39dab040cba8dfb736c65f291a6fec2b.svg";